import {
    Badge,
    Box,
    HStack,
    Table,
    Text,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import routes from "../../../routes";
import Card from "./Card";

const statusColor = {
    Approved: "green",
    Pending: "orange",
    Active: "blue",
    Suspended: "red",
    Rejected: "red",
};

const RecentReferralsTable = ({
    drivers = [],
    milestones = [],
}) => {
    const navigate = useNavigate();
  const data =
    drivers
        .filter(
            driver =>
                driver.driver
                    ?.driver_id
        )
            .sort(
                (
                    a,
                    b
                ) =>
                    new Date(
                        b.created_at
                    ) -
                    new Date(
                        a.created_at
                    )
            )
            .slice(
                0,
                5
            )
            .map(
                (
                    driver
                ) => {
                    
                   const driverId =
                        driver.driver?.driver_id ||
                        driver.driver_id;

                    const driverMilestones =
                        milestones.filter(
                            (
                                milestone
                            ) =>
                                milestone.driver_id ===
                                driverId
                        );
                    const achievedMilestones =
                        driverMilestones.filter(
                            (
                                milestone
                            ) =>
                                milestone.milestone_status ===
                                "Achieved"
                        );

                    const latestMilestone =
                        achievedMilestones[
                            achievedMilestones.length -
                                1
                        ];

                    const totalCommission =
                        achievedMilestones.reduce(
                            (
                                sum,
                                milestone
                            ) =>
                                sum +
                                Number(
                                    milestone.commission_amount ||
                                        0
                                ),
                            0
                        );

                    return {
    driver:
        [
            driver.first_name,
            driver.last_name,
        ]
            .filter(Boolean)
            .join(" ") ||
        driver.username ||
        "Unknown Driver",

    joined:
        new Date(
            driver.created_at
        ).toLocaleDateString(),

    status:
        driver.driver?.status ||
        driver.status,

    milestone:
        latestMilestone
            ?.milestone_type ||
        "Registration Started",

    deliveries:
        latestMilestone
            ?.required_value ||
        0,

    commission: `P${totalCommission.toFixed(
        2
    )}`,
};
                }
            );

    return (
        <Card
            p={0}
            overflow="hidden"
        >
            <HStack
                justify="space-between"
                p={6}
            >
                <Text
                    fontWeight="700"
                    fontSize="xl"
                >
                    Recent Recruits
                </Text>

                <Text
                    color="#2453FF"
                    cursor="pointer"
                    fontWeight="600"
                    onClick={() =>
                        navigate(
                            routes.recruits
                        )
                    }
                    _hover={{
                        textDecoration:
                            "underline",
                    }}
                >
                    View All
                </Text>
            </HStack>

            <Box overflowX="auto">
                <Table.Root
                    size="md"
                    variant="line"
                    minW="900px"
                >
                    <Table.Header bg="gray.50">
                        <Table.Row>
                            <Table.ColumnHeader>
                                Driver
                            </Table.ColumnHeader>

                            <Table.ColumnHeader>
                                Joined
                            </Table.ColumnHeader>

                            <Table.ColumnHeader>
                                Status
                            </Table.ColumnHeader>

                            <Table.ColumnHeader>
                                Milestone
                            </Table.ColumnHeader>

                            <Table.ColumnHeader textAlign="center">
                                Deliveries
                            </Table.ColumnHeader>

                            <Table.ColumnHeader textAlign="end">
                                Commission
                            </Table.ColumnHeader>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {data.map(
                            (
                                row,
                                index
                            ) => (
                                <Table.Row
                                    key={`${row.driver}-${index}`}
                                    borderBottom={
                                        index ===
                                        data.length -
                                            1
                                            ? "none"
                                            : undefined
                                    }
                                    _hover={{
                                        bg: "gray.50",
                                    }}
                                >
                                    <Table.Cell fontWeight="600">
                                        {
                                            row.driver
                                        }
                                    </Table.Cell>

                                    <Table.Cell color="gray.600">
                                        {
                                            row.joined
                                        }
                                    </Table.Cell>

                                    <Table.Cell>
                                        <Badge
                                            colorPalette={
                                                statusColor[
                                                    row
                                                        .status
                                                ] ||
                                                "gray"
                                            }
                                            borderRadius="full"
                                            px={3}
                                        >
                                            {
                                                row.status
                                            }
                                        </Badge>
                                    </Table.Cell>

                                    <Table.Cell>
                                        {
                                            row.milestone
                                        }
                                    </Table.Cell>

                                    <Table.Cell textAlign="center">
                                        {
                                            row.deliveries
                                        }
                                    </Table.Cell>

                                    <Table.Cell textAlign="end">
                                        <Text
                                            color="#2453FF"
                                            fontWeight="700"
                                        >
                                            {
                                                row.commission
                                            }
                                        </Text>
                                    </Table.Cell>
                                </Table.Row>
                            )
                        )}
                    </Table.Body>
                </Table.Root>
            </Box>
        </Card>
    );
};

export default RecentReferralsTable;